import { createNode } from '@glueapp/graph-types';

export const Round = createNode({
    id: 'Round',
    name: 'Round',
    description: 'Rounds the number to the closest full number. Examples: 0.3 becomes 0, 0.7 becomes 1 and 3.8 becomes 4',
    aiDescription:
        'Rounds a number to the nearest integer. Connect a value to the "Number" input port; the "Closest Full Number" output port provides the result.',
    category: 'Math',
    color: '#5daa5b',
    integration: undefined,
    inPorts: {
        Number: { kind: 'number' },
    },
    outPorts: {
        'Closest Full Number': { kind: 'number' },
    },
    execute: function (input) {
        const inputNumber = input.inPorts.Number;
        return { output: { 'Closest Full Number': Math.round(inputNumber) } };
    },
});
